/**
 * 翻车进度看板 - 真实接口优先，接口不可用时保留演示数据兜底。
 * 联调兜底：VUE_APP_KANBAN_DUMPER_PROGRESS_USE_MOCK=true
 */
import request from '@/router/axios'

const API = '/api/produce/wagon-tippler-efficiency-daily/dumper-progress'
const USE_MOCK_ONLY = process.env.VUE_APP_KANBAN_DUMPER_PROGRESS_USE_MOCK === 'true'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

function mockData() {
  return {
    shifts: [
      { name: '早班 (06:00-14:00)', plan: 60, completed: 48 },
      { name: '中班 (14:00-22:00)', plan: 60, completed: 0 },
      { name: '晚班 (22:00-06:00)', plan: 50, completed: 0 }
    ],
    hourlyData: [
      { hour: '08:00', value: 42 }, { hour: '09:00', value: 48 }, { hour: '10:00', value: 55 },
      { hour: '11:00', value: 52 }, { hour: '12:00', value: 50 }, { hour: '13:00', value: 46 }
    ],
    planArrival: { totalPlan: 180, actualArrived: 48, remaining: 132 }
  }
}

function normalize(raw = {}) {
  const planArrival = raw.planArrival || {}
  return {
    shifts: Array.isArray(raw.shifts) ? raw.shifts.map((item) => ({
      name: item.name || item.shiftName || item.shift || '-',
      plan: Number(item.plan != null ? item.plan : item.planCount) || 0,
      completed: Number(item.completed != null ? item.completed : item.completedCount) || 0
    })) : [],
    hourlyData: Array.isArray(raw.hourlyData) ? raw.hourlyData.map((item) => ({
      hour: item.hour || item.time || '-',
      value: Number(item.value != null ? item.value : item.count) || 0
    })) : [],
    planArrival: {
      totalPlan: Number(planArrival.totalPlan != null ? planArrival.totalPlan : planArrival.planCount) || 0,
      actualArrived: Number(planArrival.actualArrived != null ? planArrival.actualArrived : planArrival.arrivedCount) || 0,
      remaining: Number(planArrival.remaining != null ? planArrival.remaining : planArrival.remainingCount) || 0
    }
  }
}

export function fetchDumperProgress(params = {}) {
  if (USE_MOCK_ONLY) return Promise.resolve(mockData())
  return request({ url: API, method: 'post', data: params })
    .then(unwrap)
    .then(normalize)
    .catch(() => mockData())
}
